export default __webpack_public_path__ + "static/media/five-icon.44cdd29e.svg";